import { FC } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { COLORS } from '@app/constants';

interface Props {
  className?: string;
  src?: string;
  username?: string;
  width?: number;
  height?: number;
}

const Avatar: FC<Props> = ({
  className,
  src,
  username,
  width = 44,
  height = 44,
  ...props
}) => {
  const firstLetterUsername = username ? username.charAt(0).toUpperCase() : '?';

  return (
    <Root
      as={src && 'figure'}
      className={className}
      $width={width}
      $height={height}
      {...props}
    >
      {src ? (
        <Image
          src={src}
          width={width}
          height={height}
          alt={`Это аватар пользователя ${username}`}
        />
      ) : (
        firstLetterUsername
      )}
    </Root>
  );
};

export default Avatar;

interface StyleProps {
  $width?: number;
  $height?: number;
}

const Root = styled.div<StyleProps>`
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  border-radius: 50%;
  line-height: normal;
  background-color: ${COLORS.grayscale100};
  color: ${COLORS.grayscale400};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0;
  font-size: 16px;

  img {
    object-fit: cover;
  }

  span {
    padding-top: 3px;
    line-height: 1;
  }
`;
